import { Fragment, useState, useEffect} from 'react'
import { Tab } from '@headlessui/react'
import ProductDetailImageGallery from '../Cards/imageGallery'
import CompareImageGallery from '../Cards/compareImageGallery'
import ProductDetailImageGallery2 from '../Cards/imageGallery2'
const originTabs = [
  {
    id:1,
    name: '精選作品圖片',
    features: [
      {
        objectCompoent: <ProductDetailImageGallery></ProductDetailImageGallery>,
      },
    ],
  }
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ProductDetailTab(imgUrls) {
    const [showImageUrls, setShowImageUrls] = useState([]);
    const [tabs, setTabs] = useState(originTabs);
    useEffect(() => {
      setShowImageUrls(imgUrls.imgUrls);
      setTabs(
        [
          {
            name: '精選作品圖片',
            features: [
              // {
              //   objectCompoent: <ProductDetailImageGallery showImageUrls = {imgUrls.imgUrls}></ProductDetailImageGallery>,
              // },
              {
                objectCompoent:<ProductDetailImageGallery2 showImageUrls = {imgUrls.imgUrls}></ProductDetailImageGallery2>
              }
            ],
          }
        ]
      )
    }, [imgUrls.imgUrls]);

  return (
    <div className="bg-white">
      <section aria-labelledby="features-heading" className=" w-full  text-center lg:text-left pl-8">
        <div className="max-w-2xl mx-auto px-4 lg:px-0 lg:max-w-none">
          <Tab.Group as="div" className="mt-4">
            <div className="-mx-4 flex overflow-x-auto sm:mx-0">
              <div className="flex-auto px-4 border-b border-gray-200 sm:px-0">
                <Tab.List className="-mb-px flex space-x-10">
                  {tabs.map((tab) => (
                    <Tab
                      key={tab.name}
                      className={({ selected }) =>
                        classNames(
                          selected
                            ? 'border-indigo-500 text-indigo-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                          'whitespace-nowrap py-6 border-b-2 font-medium text-sm'
                        )
                      }
                    >
                      {tab.name}
                    </Tab>
                  ))}
                </Tab.List>
              </div>
            </div>

            <Tab.Panels as={Fragment}>
              {tabs.map((tab) => (
                <Tab.Panel className="space-y-16 pt-10 lg:pt-3">
                  {tab.features.map((feature) => (
                    <div className="">
                      {feature.objectCompoent}
                    </div>
                  ))}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>
      </section>
    </div>
  )
}
